import 'ress';
import './base.scss';
import './index.html';
import './app.cache';
import {createElement} from 'react';
import {createRoot} from 'react-dom/client';
import {App} from './app';
import {popups} from 'helpers';

const rootElement = document.querySelector('.root');
if (!rootElement) {
  throw new Error('Root element not found');
}

const root = createRoot(rootElement);
root.render(createElement(App));

if (module.hot) {
  module.hot.accept('./app', () => {
    console.log('\n'.repeat(10));
    popups.reset();
    root.render(createElement(App, {hot: true}));
  });
}
